<template>
  <v-simple-table
    class="expert-tool__table"
    fixed-header
  >
    <template v-slot:default>
      <tbody>
        <tr
          v-for="(rule, i) in prescriptionRules"
          :key="`${rule.key}-${i}`"
        >
          <td class="expert-tool__table-checkbox-cell">
            <v-checkbox
              v-model="selectedRules"
              :value="rule.key"
              color="success"
            ></v-checkbox>
          </td>
          <td class="expert-tool__table-item-name">{{ $ucfirst($t(rule.name, { catalog: 'app_dashboard'})) }}</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>

/**
 * Component Medication.vue
 *
 * @module Medication
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.9] app/src/APP_DASHBOARD/templates/views/ExpertTool/SportsGoalBoxes/Medication.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: 'Medication',
  props: {
    ruleType: {
      type: String,
      required: true,
    },
  },
  computed: {
    prescriptionRules() {
      return this.$store.getters['expertTool/prescriptionRules']
        .filter((item) => item.type === this.ruleType);
    },
    selectedRules: {
      get() {
        return this.$store.getters['expertTool/selectedRules'];
      },
      set(selected) {
        this.$store.dispatch('patientSummary/toggleUnsavedChanges', true);
        return this.$store.dispatch('expertTool/updateSelectedRules', selected);
      },
    },
  },
};
</script>
